import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

const flaps = {
  query(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query`, 
      { params }
    );
  },

  queryCoupon(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-coupon`,
      { params }
    );
  },

  queryRemainderBonus(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-remainder-bonus`,
      { params }
    );
  },

  queryBonusLog(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-bonus-log`,
      { params }
    );
  },

  customerLevelChange(params) {
    const formData = new FormData();

    formData.append("file", params.file);

    return https.post(
      `admin/organizations/${organization.id}/flaps/customer-level-change`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
};

export default flaps
